import React, {useEffect, useState} from "react";
import PageLoadingSpinner from "../../PageLoadingSpinner";
import {getDataGroupByMonth} from "../../../services/Trading";
import EmptyPeriodState from "../../EmptyPeriodState";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {useTranslation} from "react-i18next";
import {performanceHighchartsDark} from "../../../pages/Report/Performance/styles";

function sumSeries(arr) {
    if (!arr || !arr.length) {
        return 0;
    }
    return arr.reduce((acc, v) => acc + (Number(v) || 0), 0);
}

export default function TradingAgroupMonth({year, filter, ...props}) {
    /** null = carregando; false = sem dados; true = exibir gráfico */
    const [isData, setData] = useState(null);
    const [options, setOptions] = useState([]);
    const { t } = useTranslation();

    useEffect( () => {

        setData(null);

        getDataGroupByMonth({
            year: year,
            direction: filter[0].direction,
        }).then((data) => {
            if (!data || data === '' || !data.data || !data.data.data) {
                setData(false);
                return;
            }

            var dataWin = [];
            var dataLoss = [];
            var dataDraw = [];
            for (var key in data.data.data) {
                var item = data.data.data[key];
                dataWin.push(item['qtdeWin']);
                dataLoss.push(item['qtdeLoss']);
                dataDraw.push(item['qtdeDraw']);
            }

            const totalOps = sumSeries(dataWin) + sumSeries(dataLoss) + sumSeries(dataDraw);
            if (totalOps === 0) {
                setData(false);
                return;
            }

            setData(true);

            const {chart, legend, credits, xAxisBase, yAxisBase} = performanceHighchartsDark;

            setOptions({
                chart: {
                    type: 'column',
                    ...chart,
                },
                credits,
                legend: {
                    ...legend,
                    align: 'center',
                    verticalAlign: 'bottom',
                    layout: 'horizontal',
                    symbolRadius: 4,
                },
                title: {
                    text: null,
                },
                xAxis: {
                    categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                    crosshair: false,
                    ...xAxisBase,
                },
                yAxis: {
                    min: 0,
                    ...yAxisBase,
                    title: {
                        text: t('operations'),
                        style: yAxisBase.title.style,
                    },
                },
                series: [
                    {
                        name: t('defeats'),
                        color: '#e74a3b',
                        data: dataLoss
                    },
                    {
                        name: t('draws'),
                        color: '#9aa0b5',
                        data: dataDraw
                    },
                    {
                        name: t('victories'),
                        color: '#1cc88a',
                        data: dataWin
                    },
                ],
                tooltip: {
                    backgroundColor: 'rgba(18, 22, 42, 0.97)',
                    borderColor: 'rgba(242, 146, 5, 0.4)',
                    borderRadius: 8,
                    style: {
                        color: 'rgba(240, 244, 255, 0.98)',
                    },
                    headerFormat: '<span style="font-size:11px;color:rgba(200,210,235,0.95)">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:2px 8px 2px 0">{series.name}: </td>' +
                        '<td style="padding:2px 0;text-align:right"><b>{point.y}</b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true,
                },
                plotOptions: {
                    column: {
                        pointPadding: 0.15,
                        borderWidth: 0,
                        borderRadius: 3,
                        groupPadding: 0.12,
                    },
                },
            });
        }).catch(() => {
            setData(false);
        });
    }, [filter, year, t]);

    return (
        <div {...props}>
            {isData === null && (
                <PageLoadingSpinner minHeight={200} padding="36px 20px"/>
            )}
            {isData === false && (
                <EmptyPeriodState iconClassName="fas fa-chart-bar"/>
            )}
            {isData === true && (
                <div className="col trading-month-chart-wrap">
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                        containerProps={{className: 'trading-month-chart'}}
                    />
                </div>
            )}
        </div>
    );
}
